export default "__VITE_ASSET__ff465c35__"